module.exports = __webpack_public_path__ + "static/media/LinkedInIcon.fd0d5546.png";